import { Component, Input } from '@angular/core';
import { fromSize, fromVisibility, Size, Visibility } from '../links-utils';

@Component({
    selector: 'a-external-link-default',
    templateUrl: './a-external-link-default.component.html',
    styleUrls: [
        '../links.scss',
        './a-external-link-default.component.scss'
    ],
    standalone: false
})
export class AExternalLinkDefaultComponent {
    @Input()
    public disabled: boolean = false;

    @Input()
    public visibility: Visibility = 'LOW';

    @Input()
    public size: Size = 'DEFAULT';

    @Input()
    public target: string;

    @Input()
    public href: string;

    public fromVisibility = fromVisibility;
    public fromSize = fromSize;

    constructor() {
    }
}
